import { render, staticRenderFns } from "./CNAEDescricaoField.vue?vue&type=template&id=0b3a6919&"
import script from "./CNAEDescricaoField.vue?vue&type=script&lang=js&"
export * from "./CNAEDescricaoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports